export default {
  "nudgeTitle": "This preview covers the App Dashboard.",
  "openLiveDemo": "Open the full live demo",
  "dismiss": "Dismiss",
  "tourLabel": "Guided tour",
  "pinDownloads": "Click Downloads",
  "pinAppRow": "Expand a row",
  "pinLanguage": "Try a language",
  "pinMenu": "Open the menu",
  "pinSearch": "Search the dashboard"
} as const;
